module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_achievement07-af31e559e25616390cdc3bd133fe57f6.jpg";